module.exports = __webpack_public_path__ + "img/BY.0a7149c2.svg";